import { forwardRef } from "react";
import { people } from "../../data/demoContent";

export const ChatBubble = forwardRef(({ message, highlight }, ref) => {
  const me = message.from === "me";
  const story = message.type === "storyReply" ? people[message.story] : null;
  return (
    <div ref={ref} className={`flex ${me ? "justify-end" : "justify-start"}`} data-testid={`chat-bubble-${message.id}`}>
      <div className={`max-w-[80%] ${highlight ? "bubble-highlight" : ""}`}>
        {story && (
          <div className="mb-1.5 flex items-end justify-end gap-2" data-testid="chat-story-reply">
            <span className="text-[11px] font-medium text-white/55">You replied to {story.name}'s story</span>
            <span className="relative h-[64px] w-[44px] overflow-hidden rounded-[10px] border border-white/15">
              <img src={story.story.image} alt={`${story.name}'s story`} className="h-full w-full object-cover" />
            </span>
          </div>
        )}
        <div className={`rounded-[22px] px-4 py-2.5 text-[14px] leading-snug ${me ? "bubble-me rounded-br-[8px]" : "bubble-them rounded-bl-[8px]"}`}>
          {message.text}
        </div>
        {message.sample && <p className="mt-1 text-right text-[10px] text-white/55">Sample message · stays on this page</p>}
      </div>
    </div>
  );
});
ChatBubble.displayName = "ChatBubble";
